export default "__VITE_PUBLIC_ASSET__d8b5cb3a__"